"use client"

import React from "react"

import { ExtendedAddressRO } from "@/lib/storefront/addresses/address"
import { cn } from "@/components/ui/helpers/utils"
import AddressEditSheet from "@/components/common/addresses/AddressEditSheet"
import { AddressFields } from "@/components/common/addresses/AddressFields"
import BasicCard from "@/components/common/BasicCard"
import FallbackCard from "@/components/common/FallbackCard"

interface SelectAddressProps {
  initialAddress: ExtendedAddressRO
  addresses: ExtendedAddressRO[]
  selectedAddress: ExtendedAddressRO
  onEdit?: (address: ExtendedAddressRO) => void
  customer: any
  user: any
  isB2B: boolean
  type: "invoiceTo" | "shipTo" | "general"
}

export default function SelectAddress(props: SelectAddressProps) {
  function onEditInternal(address: ExtendedAddressRO) {
    if (props.onEdit) {
      props.onEdit(address)
    }
  }

  return (
    <div>
      {props.selectedAddress ? (
        <BasicCard className={"flex min-h-0 flex-row gap-x-6"}>
          <AddressFields address={props.selectedAddress} isB2B={props.isB2B} showEligibleIcons={true} />
          <div
            className={cn("flex w-auto flex-col items-end justify-between gap-y-6", { "justify-end": !props.onEdit })}
          >
            {props.onEdit && (
              <AddressEditSheet
                onSave={onEditInternal}
                address={props.selectedAddress}
                customer={props.customer}
                user={props.user}
                mode="edit"
                type={props.type}
              />
            )}
          </div>
        </BasicCard>
      ) : (
        <FallbackCard className={"h-96 w-full"} />
      )}
    </div>
  )
}
